import { motion } from "framer-motion";

const wrap = { hidden: {}, show: { transition: { staggerChildren: 0.08, delayChildren: 0.1 } } };
const item = { hidden: { opacity: 0, y: 22 }, show: { opacity: 1, y: 0, transition: { duration: 0.4, ease: [0.22, 0.61, 0.36, 1] } } };

export default function ChoiceStep({ chapter, title, hint, options, selected, onPick, onNext, onBack, testId }) {
  return (
    <section className="step" data-testid={testId}>
      <div className="step-inner">
        <motion.div variants={wrap} initial="hidden" animate="show">
          <motion.p className="eyebrow" variants={item}>
            <span className="mk-estrella" aria-hidden="true" /> Pregunta {chapter} de 6
          </motion.p>
          <motion.h2 className="q-title display" variants={item}>
            {title}
          </motion.h2>
          {hint && (
            <motion.p className="hint" variants={item}>
              {hint}
            </motion.p>
          )}
          <div className="opts" role="radiogroup" aria-label={title}>
            {options.map((o) => (
              <motion.button
                key={o.id}
                variants={item}
                type="button"
                role="radio"
                aria-checked={selected === o.id}
                className="opcion"
                data-testid={`${testId}-opcion-${o.id}`}
                onClick={() => onPick(o)}
              >
                <span className="op-label">{o.label}</span>
                <span className="op-sub">{o.sub}</span>
              </motion.button>
            ))}
          </div>
          <motion.div variants={item} className="form-actions">
            <button type="button" className="backlink" onClick={onBack} data-testid={`${testId}-volver`}>
              Atrás
            </button>
            <button type="button" className="btn btn-cta" onClick={onNext} data-testid={`${testId}-siguiente`}>
              Siguiente
            </button>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
